import { render, staticRenderFns } from "./PendingTeachers.vue?vue&type=template&id=694e6f92&scoped=true&lang=true&"
import script from "./PendingTeachers.vue?vue&type=script&lang=js&"
export * from "./PendingTeachers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694e6f92",
  null
  
)

export default component.exports